// File-kind detection by magic bytes — never by extension or MIME alone,
// both are attacker-suppliable (docs/14 threat model).

export type FileKind = "pdf" | "image" | "unknown";

export function fileKind(buf: ArrayBuffer): FileKind {
  const b = new Uint8Array(buf.slice(0, 8));
  const ascii = (n: number) => String.fromCharCode(...b.slice(0, n));
  if (ascii(5) === "%PDF-") return "pdf";
  if (b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4e && b[3] === 0x47) return "image"; // PNG
  if (b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) return "image";                   // JPEG
  return "unknown";
}

// A "text" PDF that yields almost no characters is a scan wrapped in a PDF.
export function looksScanned(totalChars: number, pages: number): boolean {
  return totalChars < 40 * Math.max(1, pages);
}
